var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.576 14.5a6.502 6.502 0 0 1 12.924 1A6.5 6.5 0 0 1 16 22v3a9.5 9.5 0 0 0 0-19c-4.909 0-8.948 3.723-9.448 8.5H4.396L4 15.324 7.604 20.5h.793L12 15.324l-.396-.824z",
    clipRule: "evenodd"
  })));
};
export default SvgReload;